module.exports = __webpack_public_path__ + "static/img/bg-es.bdb76c1d.png";